import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import NewsQuickList from "@/pages/home/components/NewsQuickList";
import MoviePicks from "@/pages/home/components/MoviePicks";
import TopicSection from "@/pages/home/components/TopicSection";
import Sidebar from "@/pages/home/components/Sidebar";
import { useSeo } from "@/hooks/useSeo";

const stats = [
  { value: "12,000+", label: "收录影片", icon: "ri-film-line" },
  { value: "3,500+", label: "资讯与影评", icon: "ri-newspaper-line" },
  { value: "98%", label: "用户好评率", icon: "ri-emotion-happy-line" },
  { value: "每日更新", label: "内容同步", icon: "ri-refresh-line" },
];

export default function Home() {
  useSeo({
    title: "91电影-最新电影资讯与影片推荐平台",
    description:
      "91电影为您提供丰富的电影资讯、影片推荐和影评内容，涵盖最新上映电影及经典佳作，方便用户了解并选择心仪影片。",
    keywords: "91电影,电影资讯,最新电影,影片推荐,电影平台,影视内容,电影资讯网站",
  });

  return (
    <div className="w-full">
      <h1 className="sr-only">91电影 - 最新电影资讯与影片推荐平台</h1>
      <div className="w-full px-4 md:px-8 pt-6 animate-fade-up">
        <HeroCarousel />
      </div>

      <div className="w-full px-4 md:px-8 py-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {stats.map((s) => (
            <div
              key={s.label}
              className="bg-background-50 rounded-lg border border-background-200 p-5 flex items-center gap-4"
            >
              <span className="w-12 h-12 shrink-0 rounded-md bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className={`${s.icon} text-2xl`} />
              </span>
              <div className="min-w-0">
                <p className="font-heading font-extrabold text-lg md:text-xl text-foreground-950 truncate">
                  {s.value}
                </p>
                <p className="text-xs md:text-sm text-foreground-500">{s.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="w-full px-4 md:px-8 pb-14">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8">
          <div className="flex flex-col gap-12 min-w-0">
            <NewsQuickList />
            <MoviePicks />
            <TopicSection />
          </div>
          <Sidebar />
        </div>
      </div>

      <section className="w-full bg-primary-700">
        <div className="w-full px-4 md:px-8 py-14">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <span className="inline-flex items-center gap-1 bg-accent-500 text-secondary-950 text-xs font-bold rounded-md px-3 py-1 mb-4">
                <i className="ri-book-open-line" />
                网站简介
              </span>
              <h2 className="font-heading font-extrabold text-2xl md:text-3xl text-background-50 leading-snug">
                让每一次观影选择
                <br className="hidden md:block" />
                都更简单、更有依据
              </h2>
              <p className="text-background-200/90 text-sm md:text-base mt-4 max-w-xl leading-relaxed">
                91电影专注于电影资讯与影片推荐，涵盖国内外最新电影报道、影片简介、观影指南与经典影片介绍。
                我们用清晰的分类、多维的筛选和真诚的影评，帮助你快速找到想看的那一部。
              </p>
              <div className="flex flex-wrap gap-3 mt-7">
                <Link
                  to="/category/recommend"
                  className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-secondary-950 text-sm font-bold rounded-md px-5 py-2.5 transition-colors whitespace-nowrap cursor-pointer"
                >
                  浏览影片推荐
                  <i className="ri-arrow-right-line" />
                </Link>
                <Link
                  to="/category/news"
                  className="inline-flex items-center gap-2 border border-background-50/30 hover:bg-background-50/10 text-background-50 text-sm font-medium rounded-md px-5 py-2.5 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看最新资讯
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {[
                { title: "最新资讯", desc: "每日同步上映动态与行业观察", icon: "ri-newspaper-line" },
                { title: "精选推荐", desc: "多维筛选，快速定位心头好", icon: "ri-star-line" },
                { title: "深度影评", desc: "不止评分，更有观点的碰撞", icon: "ri-chat-quote-line" },
                { title: "观影指南", desc: "专题影单，一次看个够", icon: "ri-play-list-line" },
              ].map((card) => (
                <div
                  key={card.title}
                  className="bg-background-50/10 border border-background-50/15 rounded-lg p-4 md:p-5"
                >
                  <span className="w-11 h-11 rounded-md bg-accent-500 text-secondary-950 flex items-center justify-center mb-3">
                    <i className={`${card.icon} text-xl`} />
                  </span>
                  <p className="font-heading font-bold text-background-50 text-base">{card.title}</p>
                  <p className="text-xs md:text-sm text-background-200/80 mt-1.5 leading-relaxed">
                    {card.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}